import React, { createContext, useContext, useEffect, useState } from "react";
import { getAdminInfo } from "../services/apis/users";

const InfoContext = createContext(undefined);

export const InfoProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    getAdminInfo()
      .then((res) => {
        setData(res?.data || {});
      })
      .catch((err) => {
        setError(err?.message || "Failed to load org info");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <InfoContext.Provider value={{ data, loading, error, refetch: fetchData }}>
      {children}
    </InfoContext.Provider>
  );
};

export const useInfo = () => {
  const context = useContext(InfoContext);
  if (!context) {
    throw new Error("useInfo must be used within ApiProvider");
  }
  return context;
};
